import { makeColorToken } from './token.color.js';
import { makeGenericToken } from './util.make-generic-token.js';

function makeInteractiveColorToken(propName, input) {
  const tokens = {
    default: typeof input.default === "string" ? makeColorToken(`${propName}--default`, input.default) : input.default.__extend(`${propName}--default`),
    hover: typeof input.hover === "string" ? makeColorToken(`${propName}--hover`, input.hover) : input.hover.__extend(`${propName}--hover`),
    active: typeof input.active === "string" ? makeColorToken(`${propName}--active`, input.active) : input.active.__extend(`${propName}--active`)
  };
  return makeGenericToken(function format(options) {
    switch (options?.state) {
      case "hover":
        return tokens.hover(options);
      case "active":
        return tokens.active(options);
      default:
        return tokens.default(options);
    }
  }, function override(nextValue) {
    if (nextValue === undefined) {
      return {};
    }
    return {
      ...tokens.default.__override(nextValue.default),
      ...tokens.hover.__override(nextValue.hover),
      ...tokens.active.__override(nextValue.active)
    };
  }, function extend(propName, token) {
    return makeInteractiveColorToken(propName, token);
  }, {
    default: tokens.default,
    hover: tokens.hover,
    active: tokens.active
  });
}

export { makeInteractiveColorToken };
//# sourceMappingURL=token.color.interactive.js.map
